import { useState, useEffect } from 'react';
import { useStore } from '@betgames/bg-state-manager';
import { GameId } from '@bg-shared/enums/GameId';
import { topWonAmountsEntity } from '../TopWonAmounts.entity';

interface IUseTopWonAmounts {
    isLoading: boolean;
    amounts: number[];
}

const subscriptions = new Set<GameId>();

export const useTopWonAmounts = (gameId: GameId): IUseTopWonAmounts => {
    const amounts = useStore(topWonAmountsEntity.store(gameId));
    const [isLoading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (amounts.length || subscriptions.has(gameId)) {
            return;
        }

        topWonAmountsEntity.initAmounts(gameId).then(() => {
            topWonAmountsEntity.subscribeForUpdates(gameId);
            subscriptions.add(gameId);
        });
    }, []);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setLoading(false);
        }, 2000);

        return () => {
            clearTimeout(timeout);
        };
    }, [amounts]);

    return {
        amounts,
        isLoading,
    };
};
